export const classroomFirstLandingPageStorageKey = "classroomFirstLandingPage";

const localePathPattern = /^\/[a-z]{2}(?:-[A-Z]{2})?(?=\/|$)/;

const marketingParameterKeys = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export const getClassroomLandingPagePath = (pathname) => {
  const pathWithoutLocale = pathname.replace(localePathPattern, "");

  return pathWithoutLocale || "/";
};

export const storeClassroomFirstLandingPage = ({ pathname, search }) => {
  if (localStorage.getItem(classroomFirstLandingPageStorageKey)) return;

  const landingPage = getClassroomLandingPagePath(pathname);

  const marketingParams = Object.fromEntries(
    [...new URLSearchParams(search).entries()].filter(([key]) =>
      marketingParameterKeys.includes(key),
    ),
  );

  const landingPageData = {
    landing_page: landingPage,
  };

  if (Object.keys(marketingParams).length > 0) {
    landingPageData.marketing_parameters = marketingParams;
  }

  localStorage.setItem(
    classroomFirstLandingPageStorageKey,
    JSON.stringify(landingPageData),
  );
};

export const readClassroomFirstLandingPage = () => {
  try {
    return JSON.parse(
      localStorage.getItem(classroomFirstLandingPageStorageKey) || "{}",
    );
  } catch {
    return {};
  }
};
